import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ComponentsModule } from "./shared/components/components.module";
import { NavBarComponent } from "./pages/nav-bar/nav-bar.component";

import { FormsModule } from "@angular/forms";
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { LOCALE_ID } from '@angular/core';
import { en_US, NZ_I18N, zh_CN } from "ng-zorro-antd/i18n";
import { ja_JP } from "ng-zorro-antd/i18n";
import { registerLocaleData } from "@angular/common";
import ja from "@angular/common/locales/ja";
import en from '@angular/common/locales/en';
import zh from '@angular/common/locales/zh';

import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzMenuModule } from "ng-zorro-antd/menu";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';

import { NzResultModule } from 'ng-zorro-antd/result';
import { AuthModule } from "@auth0/auth0-angular";
import { environment as env } from "./shared/auth0/environment";
import { InterceptorService } from "./shared/interceptor/interceptor.service";

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PageNotPermissionComponent } from './pages/page-not-permission/page-not-permission.component';


registerLocaleData(en);
registerLocaleData(zh);
registerLocaleData(ja);

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json')
}

@NgModule({
  declarations: [AppComponent, NavBarComponent, PageNotPermissionComponent],
  imports: [
    BrowserModule,
    ComponentsModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NzLayoutModule,
    NzMenuModule,
    NzModalModule,
    NzIconModule,
    NzResultModule,
    NzDropDownModule,
    NzPopconfirmModule,
    NzSelectModule,
    AuthModule.forRoot({
      ...env.auth,
      // httpInterceptor: {
      //   ...env.httpInterceptor,
      // },
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      },
    })
  ],
  providers: [
    { 
      provide: NZ_I18N,
      useFactory: (localeId: string) => {
        switch(localeId) {
          case 'en' : return en_US;
          case 'zh' : return zh_CN;
          case 'jp' : return ja_JP;
          default: return zh_CN;
        }
      },
      deps: [LOCALE_ID]
    },

    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
